import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';

import {useEffect} from 'react';

export function AutoFocusPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.focus();
  }, [editor]);

  return null;
}
